export { default } from 'next/link';
